import React, { Fragment, useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import StorefrontIcon from '@material-ui/icons/Storefront';
import StorefrontRoundedIcon from '@material-ui/icons/StorefrontRounded';
import Button from '@material-ui/core/Button';
import { PackageCard, SelectFieldOne, ButtonOne, TextInputFixedLabel, PhoneInputField, } from "master-react-lib";

import './OrderForm.css'

import { useSelector, useDispatch } from 'react-redux'
import { setRequesterInfo } from '../../features/counter/counterSlice'

const DeliveryMethod = (props) => {    

    const rInfo = useSelector((state) => state.counter.requesterInfo);

    const [shippingDetails, setShippingDetails] = useState(rInfo);

    useEffect( ()=>{

        // if( rInfo.shippingAddressSameAsBilling){
            setShippingDetails(
                {                
                    ['firstName']: rInfo.shipppingFirstName,
                    ['lastName']: rInfo.shippingLastName, 
                    ['email']: rInfo.shippingEmail, 
                    ['phone']: rInfo.shippingPhone, 
                    ['streetAddress']: rInfo.shippingStreetAddress , 
                    ['floorNumber']: rInfo.shippingFloorNumber , 
                    ['city']: rInfo.shippingCity , 
                    ['state']: rInfo.shippingState , 
                    ['postalCode']: rInfo.shippingPostalCode ,
                    
                }
            );

            // console.log( setShippingDetails);
        // };

    }, []);
    
    const dispatch = useDispatch();
    const [phone, setPhone] = React.useState({
        country: "",
        number: "",
    });

    const cardFunction = (value) => {
        (value) && console.log("clicked");
    };

    const continueClicked = () => {
        console.log("Continue Button Clicked");
    };

    const selectState = [
        { value:"AL", select: "Alabama"}, { value:"AK", select: "Alaska"}, { value:"AS", select: "American Samoa"}, { value:"AZ", select: "Arizona"}, { value:"AR", select: "Arkansas"}, { value:"CA", select: "California"}, { value:"CO", select: "Colorado"}, { value:"CT", select: "Connecticut"}, { value:"DE", select: "Delaware"}, { value:"DC", select: "District Of Columbia"}, { value:"FM", select: "Federated States Of Micronesia"}, { value:"FL", select: "Florida"}, { value:"GA", select: "Georgia"}, { value:"GU", select: "Guam"}, { value:"HI", select: "Hawaii"}, { value:"ID", select: "Idaho"}, { value:"IL", select: "Illinois"}, { value:"IN", select: "Indiana"}, { value:"IA", select: "Iowa"}, { value:"KS", select: "Kansas"}, { value:"KY", select: "Kentucky"}, { value:"LA", select: "Louisiana"}, { value:"ME", select: "Maine"}, { value:"MH", select: "Marshall Islands"}, { value:"MD", select: "Maryland"}, { value:"MA", select: "Massachusetts"}, { value:"MI", select: "Michigan"}, { value:"MN", select: "Minnesota"}, { value:"MS", select: "Mississippi"}, { value:"MO", select: "Missouri"}, { value:"MT", select: "Montana"}, { value:"NE", select: "Nebraska"}, { value:"NV", select: "Nevada"}, { value:"NH", select: "New Hampshire"}, { value:"NJ", select: "New Jersey"}, { value:"NM", select: "New Mexico"}, { value:"NY", select: "New York"}, { value:"NC", select: "North Carolina"}, { value:"ND", select: "North Dakota"}, { value:"MP", select: "Northern Mariana Islands"}, { value:"OH", select: "Ohio"}, { value:"OK", select: "Oklahoma"}, { value:"OR", select: "Oregon"}, { value:"PW", select: "Palau"}, { value:"PA", select: "Pennsylvania"}, { value:"PR", select: "Puerto Rico"}, { value:"RI", select: "Rhode Island"}, { value:"SC", select: "South Carolina"}, { value:"SD", select: "South Dakota"}, { value:"TN", select: "Tennessee"}, { value:"TX", select: "Texas"}, { value:"UT", select: "Utah"}, { value:"VT", select: "Vermont"}, { value:"VI", select: "Virgin Islands"}, { value:"VA", select: "Virginia"}, { value:"WA", select: "Washington"}, { value:"WV", select: "West Virginia"}, { value:"WI", select: "Wisconsin"}, { value:"WY", select: "Wyoming"}
    ];

    const handleChange = (prop) => (event) => {
        // console.log(event.target.value, value);
    };

    const editButtonClick = ( e ) =>{
        console.log('hi')
    }
    const [visibleContinueButton, setVisibleContinueButton] = useState( false );


    return (
        <div className="Delivery">
            <Grid container spacing={2}>

                <Grid item xs={12} md={12}>
                    <div className='FormDetailsContainer'>
                        <div className='FormDetailsContainerHdr'>
                            <div className='FormDetailsContainerDtl'>
                                 <h3>Delivery information</h3>
                                <h2>{shippingDetails.firstName}</h2>
                                <p>{shippingDetails.streetAddress}</p>
                                <p> {shippingDetails.floorNumber} </p>
                                <p>{shippingDetails.city}, {shippingDetails.state} {shippingDetails.postalCode}</p>
                            </div>
                            <div className='AtdRightCol'>
                                <Button onClick={props.clickEditButton} className='atnEdit'>
                                    Edit
                                </Button>
                                {/* <Button href="#text-buttons" className='atnDelete'>
                                    Delete
                                </Button> */}
                            </div>
                        </div>

                    </div>
                </Grid>

            </Grid>





        </div>

    )
}

export default DeliveryMethod;